import { Button, Select, Tooltip } from 'antd';
import { RotateRightOutlined, RotateLeftOutlined, SwapOutlined } from '@ant-design/icons';

import ToolItem from './ToolItem';
import { SContainer } from './Tools.styles';

const ToolsBar = ({
  formValue,
  imagePlaces,
  scalingMethods,
  onDownload,
  onRotateLeft,
  onRotateRight,
  onFlip,
  onChange,
}) => {
  return (
    <SContainer>
      <ToolItem>
        <Select
          style={{ width: '100%' }}
          options={imagePlaces}
          value={formValue.place}
          onSelect={(value) => onChange('place', value)}
        />
      </ToolItem>
      <ToolItem>
        <Select
          style={{ width: '100%' }}
          options={scalingMethods}
          value={formValue.type}
          onSelect={(value) => onChange('type', value)}
        />
      </ToolItem>
      <ToolItem>
        <Tooltip title="Roteer 90 graden naar links">
          <Button
            icon={<RotateLeftOutlined />}
            onClick={onRotateLeft}
            style={{ marginRight: 10 }}
          />
        </Tooltip>
        <Tooltip title="Roteer 90 graden naar rechts">
          <Button
            icon={<RotateRightOutlined />}
            onClick={onRotateRight}
            style={{ marginRight: 10 }}
          />
        </Tooltip>
        <Tooltip title="Horizontaal spiegelen">
          <Button icon={<SwapOutlined />} onClick={onFlip} />
        </Tooltip>
      </ToolItem>

      <ToolItem>
        <Button type="primary" onClick={onDownload}>
          Download
        </Button>
      </ToolItem>
    </SContainer>
  );
};

export default ToolsBar;
